import clsx from "clsx";

export function DetailCard({
  title,
  icon,
  children,
  className,
  bodyClassName,
}: {
  title: React.ReactNode; // Plain string aur JSX element dono support karega
  /** A small glyph for what the card holds — dates, people, parties — so the
   *  sections can be told apart while scrolling rather than only by reading
   *  each heading. Tinted with the accent and marked aria-hidden: it repeats
   *  the title, it doesn't add to it. */
  icon?: React.ReactNode;
  children: React.ReactNode;
  /** Extra classes on the card itself — used to make a card span both
   *  columns of a two-column detail layout. */
  className?: string;
  /** Overrides the single-column body grid, for a card whose fields read
   *  better side by side. */
  bodyClassName?: string;
}) {
  return (
    <div
      className={clsx(
        "bg-[rgb(var(--card))]",
        "border border-[rgb(var(--border))]",
        "rounded-2xl p-4 shadow-lifted sm:p-5",
        className,
      )}
    >
      <h3 className="mb-4 flex items-center gap-2.5 text-sm font-semibold text-[rgb(var(--text-primary))]">
        {icon && (
          <span
            aria-hidden
            className="flex h-8 w-8 shrink-0 items-center justify-center rounded-xl bg-[rgb(var(--text-accent))]/10 text-[rgb(var(--text-accent))]"
          >
            {icon}
          </span>
        )}
        {title}
      </h3>

      <div className={clsx("grid gap-x-6 gap-y-0", bodyClassName)}>{children}</div>
    </div>
  );
}
